import { defineQuery } from 'bitecs';
import { Animal, AI, Production, Position, Tile, Plant, SoundLevel, Corpse } from '../world.js';

// Create all queries
export const animalQuery = defineQuery([Animal, AI]);
export const tileQuery = defineQuery([Tile]);
export const plantQuery = defineQuery([Plant]);
export const playerQuery = defineQuery([Position]);
export const corpseQuery = defineQuery([Corpse]); 